import { render, staticRenderFns } from "./Socials.vue?vue&type=template&id=d6c597aa&scoped=true&"
import script from "./Socials.vue?vue&type=script&lang=ts&"
export * from "./Socials.vue?vue&type=script&lang=ts&"
import style0 from "./Socials.vue?vue&type=style&index=0&id=d6c597aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c597aa",
  null
  
)

export default component.exports